module.exports = __webpack_public_path__ + "static/img/1.2871c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/1.png
// module id = fCJX
// module chunks = 12